import * as React from 'react';
import { FC } from 'react';
import { JackpotAggregatorCampaignViewProps } from './types';
import JackpotView from './JackpotView';
import Rules from './Rules';
import Leaderboards from './Leaderboards';
import { LocalesContext } from './locales';

const JackpotAggregatorCampaign: FC<JackpotAggregatorCampaignViewProps> = (props) => (
  <LocalesContext.Provider value={props.locales}>
    <div className="jackpot_widget j-w">
      <div className="j-w_range jw-range">
        <ul className="jw-range_list" aria-label="range-list">
          {props.jackpot_views.map((j) => (
            <JackpotView key={j.name} jackpotView={j} currency={props.currency} />
          ))}
        </ul>
      </div>
      <Rules {...props} />
      <Leaderboards {...props} />
    </div>
  </LocalesContext.Provider>
);

const WrappedLottery: FC<JackpotAggregatorCampaignViewProps> = (props) => <JackpotAggregatorCampaign {...props} />;

export default WrappedLottery;
